import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import Btn from '../Btn/Btn';
import { TreeState } from '../../store/treeStore/treeStore';

type Props = {
    stateFromStorage: TreeState;
    onConfirm: () => void;
    onDeny: () => void;
};

const RestoreQuestionnaireModal = ({ stateFromStorage, onConfirm, onDeny }: Props): JSX.Element => {
    const { t } = useTranslation();

    return (
        <Modal title={t('Restore questionnaire...')} close={onDeny}>
            <div>
                <p>{t('It looks like you have previously worked with a questionnaire:')}</p>
                <div className="key-value">
                    <div>{t('Title')}</div>
                    <div>{stateFromStorage?.qMetadata.title}</div>
                </div>
                <div className="key-value">
                    <div>{t('Technical name')}</div>
                    <div>{stateFromStorage?.qMetadata.name}</div>
                </div>
                <div className="key-value">
                    <div>{t('Version')}</div>
                    <div>{stateFromStorage?.qMetadata.version}</div>
                </div>
                <p>{t('Do you wish to open this questionnaire?')}</p>
                <div className="modal-btn-bottom">
                    <div className="center-text">
                        <Btn title={t('Yes')} type="button" variant="primary" onClick={onConfirm} />{' '}
                        <Btn title={t('No')} type="button" variant="secondary" onClick={onDeny} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default RestoreQuestionnaireModal;
